<Page>
  <Navbar title="About" backLink="Back" />
  <BlockTitle>About</BlockTitle>
  <Block strong>
    <p>---</p>
</Block>
  <Block strong>
    <p>---</p>
  </Block>
</Page>
<script>
  import { Page, Navbar, Block, BlockTitle } from 'framework7-svelte';
</script>
